import { DatadogClient } from '@workivate/tho-web-shared';

export const USL_FLOW_EVENT_NAME = 'usl_flow_identified';

// Flow types tracked from wa-hermes (token-based bypass flows).
// The matching set for lw-unified-identity-app lives in
// src/utils/services/datadog/usl-flow-tracking.ts in that repo.
// Both files must use the same event name and attribute names.
export const UslFlowType = {
  IDP_INITIATED_SSO: 'IDP_INITIATED_SSO',
  IDP_INITIATED_SIGN_UP: 'IDP_INITIATED_SIGN_UP',
  SSOX: 'SSOX',
  DEEPLINK: 'DEEPLINK',
  NATIVE_WEBVIEW: 'NATIVE_WEBVIEW',
} as const;

export type UslFlowTypeValue = (typeof UslFlowType)[keyof typeof UslFlowType];

export const trackUslFlow = (flowType: UslFlowTypeValue): void => {
  DatadogClient.addAction(USL_FLOW_EVENT_NAME, {
    flow_type: flowType,
    app: 'hermes',
  });
};
